import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class menuComponent implements OnInit {
  @Input() data: any;
  @Input() trigger: string;
  @Input() fieldName: string;
  @Input() isRoot :boolean = false;
  filterOptions: any;
  @Output() optionSelected = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    if (!this.data.filterOptions) {
      // nested child
      this.filterOptions = this.data.value;
    } else {
      // root child
      this.filterOptions = this.data.filterOptions;
    }
    
    this.trigger = this.trigger ?? this.filterOptions[0]?.key;
    this.fieldName = this.fieldName ?? this.data.filterFieldName;
  }

  isExpandable(node: { key: string; value: any }): boolean {
    return node.value && typeof node.value === 'object';
  }

  selectOption(option: { key: string; value: string }, fieldName: string) {
    // propagate event from first(root) child to parent (reportfilterComponent)
    this.trigger = option.key;
    this.optionSelected.emit({ option, fieldName });
  }

  onChildOptionSelected(event : {option:{key:string,value:string},fieldName:string}) {
    // propagate event from nested children up to parent
    const { option, fieldName } = event;
    this.trigger = option.key;
    this.optionSelected.emit({ option, fieldName });
  }
}
